import { BrowserRouter } from "react-router-dom"
import { AuthProvider } from "./context/AuthContext"
import { StoreProvider } from "./context/StoreContext"
import { Routers } from "./routers"
import { Provider } from "react-redux"
import store from "./store"
import { Toaster } from "react-hot-toast"
import PwaInstallPrompt from "./components/PwaInstallPrompt"


export default function App() {
  return (
    <Provider store={store}>
      <AuthProvider>
        <StoreProvider>
          <BrowserRouter>
            <Routers />
            <Toaster position="top-right" />
            <PwaInstallPrompt />
          </BrowserRouter>
        </StoreProvider>
      </AuthProvider>
    </Provider>
  )
}
